import keyBy from 'lodash/keyBy';
/**
 * 플랫 배열을 계층 구조로 전환합니다.
 * @param array
 * @param idKey 엘리먼트의 유니크 키 이름.
 * @param parentKey 엘리먼트의 부모키 이름.
 * @param childrenKey 엘리먼트에 계층 구조를 만들 때 자식키로 사용할 이름.
 * @returns {[]}
 */
export default function (array, { idKey = 'id', parentKey = 'parentId', childrenKey = 'children' } = {}) {
  const map = keyBy(array, e => e[idKey]);
  const result = [];
  for (const node of array) {
    const pid = node[parentKey];
    const parent = map[pid];
    if (pid && parent) {
      if (!parent[childrenKey]) {
        parent[childrenKey] = [];
      }
      parent[childrenKey].push(node);
    } else {
      result.push(node);
    }
  }
  return result;
}
